import { models } from '@kurtosys/ksys-app-template';

export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '0e49df93-d340-4437-8951-33359a8165ec',
	serviceUrl: 'https://api-rel.fundpress.io',
};
